import Mock from 'mockjs'

const mockData = Mock.mock({
  'data|3-6': [{
    'name': '@NAME',
    'creatDate': '@DATE',
    'address': '@CITY',
    'zip': '@ZIP'
  }]
})

export default {
  data: null,
  columns: [
    {
      label: '姓名',
      prop: 'name'
    },
    {
      label: '会员账号',
      prop: 'mobile'
    },
    {
      label: '身份证',
      prop: 'idCard'
    },
    {
      label: '会员类别',
      prop: 'type'
    },
    {
      label: '性别',
      prop: 'gender'
    },
    {
        label: '级别',
        prop: 'level'
    },
    {
        label: '总积分',
        prop: 'scoreNum'
    },
    {
        label: '年度积分',
        prop: 'yearScore'
    },
    {
        label: '参赛次数',
        prop: 'gameNum'
    },
    {
      label: '参训次数',
      prop: 'trainCount'
    },
    {
        label: '争议次数',
        prop: 'argueNum'
    },
    {
        label: '状态',
        prop: 'byx1'
    }
  ]
}
